import classNames from 'classnames';
import { Breadcrumb } from 'flowbite-react';
import { useNavigate } from 'react-router-dom';

const breadcrumbItems = [
	{
		label: 'Home',
		link: '/',
	},
	{
		label: 'Applications',
	},
];

const MyApplicationsBreadcrumbs = () => {
	const router = useNavigate();
	return (
		<>
			<Breadcrumb aria-label={'my-applications'}>
				{breadcrumbItems.map((item, i) => (
					<Breadcrumb.Item
						key={i}
						onClick={() => {
							if (item.link) router(item.link);
						}}
					>
						<p
							className={classNames('max-w-md font-inter truncate text-ellipsis text-sm font-medium dark:text-[#EBEBF0] text-[#555770]', {
								'cursor-pointer': item.link,
							})}
						>
							{item.label}
						</p>
					</Breadcrumb.Item>
				))}
			</Breadcrumb>
		</>
	);
};

export default MyApplicationsBreadcrumbs;
